const SESSION_KEYS = [
  "token",
  "tokenType",
  "tokenExpiryInSeconds",
  "role",
  "firstName",
  "lastName",
  "userName",
  "userId",
];

// A session is valid when a token exists and has not passed its expiry.
// A missing expiry is treated as "no expiry set", so the session stays valid.
export const hasValidSession = () => {
  if (!sessionStorage.getItem("token")) return false;

  const expiry = Number(sessionStorage.getItem("tokenExpiryInSeconds"));
  return !expiry || Math.floor(Date.now() / 1000) < expiry;
};

// Stores a one-time message for the login page, for example after sign-out or an expired session.
export const setAuthNotice = (type, text) => {
  sessionStorage.setItem("authNotice", JSON.stringify({ type, text }));
};

// Returns the stored message once and removes it, so it is shown a single time.
export const takeAuthNotice = () => {
  const raw = sessionStorage.getItem("authNotice");
  sessionStorage.removeItem("authNotice");
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

// Removes every session value so a stale token or name is never shown.
export const clearSession = () => {
  SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
};
